import { ICalendarLesson } from "../../../entities/calendar";
import {
    formatCalendarDayTime,
    getCalendarDaySlots,
    getCalendarDayStart,
    getCalendarDayVisibleRange,
    getCalendarEventTimeRange,
    getCalendarSlotDateEnd,
} from "../../../shared/lib/helpers/calendarDayDate";

export const formatTime = formatCalendarDayTime
export const getDayStart = getCalendarDayStart
export const getDaySlots = getCalendarDaySlots
export const getSlotDateEnd = getCalendarSlotDateEnd

export const getLessonTimeRange = (
    lesson: ICalendarLesson,
    timeFormatter = formatTime,
): string => {
    return getCalendarEventTimeRange(lesson, timeFormatter)
}

export const getVisibleRange = getCalendarDayVisibleRange
